import { Table } from "reactstrap";
import Tbody from './tbody';
import Thead from './thead';

export {
  Table,
  Tbody,
  Thead
}



// WEBPACK FOOTER //
// ./src/new-components/admin/table/index.js